










































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { SubscriptionPackageItem } from "@/types/subscriptionPackage";
import { HttpService } from "@/services/api/httpService";
import axios, { AxiosError } from "axios";
import { ClientProperty } from "@/types/client";

@Component
export default class DashboardClientProperty extends Vue {
  httpService = new HttpService<ClientProperty>();
  responseArray = new Array<ClientProperty>();
  showModal: boolean = false;
  clientId: any = "";
  removeData = new ClientProperty();
  async getList() {
    let httpService = new HttpService<Array<ClientProperty>>();
    const response = await httpService.getList(
      `clients/${this.clientId}/properties`
    );
    this.responseArray = response.data;
    this.$emit("finishedLoading", true);
  }

  @Watch("$route", { immediate: true }) onRouteChanged() {
    this.clientId = this.$route.params.id;
    this.getList();
  }

  edit(clientProperty: ClientProperty) {
    this.$router.push({
      name: "clientPropertyEdit",
      params: {
        id: this.clientId,
        clientPropertyId: clientProperty.id
      }
    });
  }

  confirmRemove(data: ClientProperty) {
    this.showModal = true;
    this.removeData = data;
  }
  async remove(data: ClientProperty) {
    const response = await this.httpService.deleteItem(
      `clients/${data.clientId}/properties`,
      data.id
    );

    this.responseArray = this.responseArray.filter(
      (item: ClientProperty) => item.clientId != data.clientId,
      this.$notification.success(`${data.value} successfully removed!`)
    );

    this.showModal = false;
    this.getList();
  }
}
